<div>
  <a routerLink="/admin">
    <mat-icon>home</mat-icon>
    Oversikt</a>
  <a routerLink="/admin/shipments">
    <mat-icon>list_alt</mat-icon>
    Alle sendinger</a>
  <a routerLink="/admin/shipments/deviated">
    <mat-icon>error</mat-icon>
    Sendinger med avvik</a>
  <a *ngIf="showShipmentAssign()" routerLink="/admin/shipments/assign">
    <mat-icon>assignment_ind</mat-icon>
    Tildel sendinger</a>
  <a *ngIf="showOrderAssign()" routerLink="/admin/orders">
    <mat-icon>assignment_ind</mat-icon>
    Tildel turer
  </a>
  <a routerLink="/admin/users">
    <mat-icon>supervisor_account</mat-icon>
    Brukere</a>
  <a routerLink="/admin/deviation/definitions">
    <mat-icon>settings</mat-icon>
    Avviksårsaker</a>
</div>

<app-user-info (onLogout)="onLogout.emit()">
</app-user-info>
